import styles from "./SubmitStage.module.css";
import SubmitButton from "../../../../../components/Button/SubmitButton/SubmitButton";
import { useTranslation } from "react-i18next";

interface SubmitStageProps {
    onBack?: () => void;
}

const SubmitStage = ({ onBack }: SubmitStageProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.FormBlock}>
            <div className={styles.FormSubtitle}>
                <p>{t("forgot_password.reset_sent")}</p>
            </div>
            <p className={styles.Hint}>{t("forgot_password.go_back")}</p>
            <SubmitButton text={t("buttons.back")} onClick={onBack} />
        </div>
    );
};

export default SubmitStage;
